import React from 'react';
import { atom, useAtom } from 'jotai';

import FormModalTrigger from '~/components/form/form-modal-trigger';
import ToggleSwitch from '~/components/inputs/toggle-switch';
import VideoPlayer from '~/components/static/video-player/video-player';
import { useProductData } from '~/features/products/products-actions';
import { CHANNEL_FUNNEL } from '~/utils/channels';

import styles from '~/components/lawns/questionnaire/weed-warrior-interstitial.module.scss';

export const addProductAtom = atom({ weedWarriorSelected: false });

export const WeedWarriorContent = ({ handleGoBack, handleSubmit }) => {
  const { product } = useProductData({
    slug: 'weed-warrior-starter-pack',
  });

  // Transforming the product data to show minimized/custom modal content
  // Using 'pspDetailsModalCopy' to render custom modal copy rather than default
  const weedWarriorProduct = {
    productDetails: {
      customBadge: 'BEST SELLER',
      pdpFlexContent: product?.productDetails?.pdpFlexContent,
      primaryImage: product?.productDetails?.primaryImage,
      primaryImagePreview: product?.productDetails?.primaryImagePreview,
      pspDetailsModalCopy: product?.productDetails?.pspDetailsModalCopy,
      sku: product?.productDetails?.sku,
      name: 'Weed Warrior',
      shortDescription: product?.productDetails?.shortDescription,
      slug: product?.productDetails?.slug,
      inStock: true,
    },
    purchaseSku: {
      image: product?.purchaseSku?.image,
      isSubscriptionManagementAddOnEligible:
        product?.purchaseSku?.isSubscriptionManagementAddOnEligible,
      skuId: product?.purchaseSku?.skuId,
      subscriptionType: product?.purchaseSku?.subscriptionType,
      title: product?.purchaseSku?.title,
      uuid: product?.purchaseSku?.uuid,
    },
  };

  const [{ weedWarriorSelected }, setProduct] = useAtom(addProductAtom);

  const handleChange = () => {
    setProduct({ weedWarriorSelected: !weedWarriorSelected });
  };

  return (
    <div className={styles.weedWarriorContent}>
      <p>
        Your weed situation may need <strong>our strongest solution</strong>.
        Not in all plans, but available when you need a lawn reset before
        seeding or to clear hardscapes.
      </p>
      <div className={styles.badgeWrapper}>
        <p>RECOMMENDED FOR YOUR YARD</p>
      </div>
      <FormModalTrigger
        className={styles.modalWrapper}
        buttonCopy="Weed Warrior Herbicide Concentrate"
        modalName="PRODUCT_DETAIL"
        options={{
          channel: CHANNEL_FUNNEL,
          product: weedWarriorProduct,
          showAtc: false,
          showViewDetailsLink: false,
          showPspCopy: true,
        }}
      />

      <div className={styles.wwVideoContainer}>
        <VideoPlayer
          className={styles.wwVideo}
          eventName="Weed Warrior Herbicide Concentrate"
          videoSrc="/videos/2024-weed-warrior-concentrate-1200x800.mp4"
          videoType="video/mp4"
        />
        <div className={styles.switchContainer}>
          <p>
            {weedWarriorSelected
              ? 'Yes, please add to my plan!'
              : 'No, thanks. I’ll skip it.'}
          </p>
          <ToggleSwitch
            ariaLabel="Add Weed Warrior Herbicide Concentrate to plan"
            checked={weedWarriorSelected}
            handleChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
};
